var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { ToolbarWithProps, Button } from '../common/Toolbar';
import Loading from '../common/Loading';
import { Body } from '../root/PageRouter';
import { AlertDialog } from '../common/alert-dialog';
import { List, ListItemInput, ListItemTextArea, ListItemSwitch, } from '@bootstraplabs/bsw-common-react';
export function UpdateEventPageUI(props) {
    // State
    var _a = React.useState(''), name = _a[0], setName = _a[1];
    var _b = React.useState(''), description = _b[0], setDescription = _b[1];
    var _c = React.useState(false), published = _c[0], setPublished = _c[1];
    var _d = React.useState(false), deleteDialogIsOpen = _d[0], setDeleteDialogIsOpen = _d[1];
    React.useEffect(function () {
        if (props.name) {
            setName(props.name);
        }
        if (props.description) {
            setDescription(props.description);
        }
        if (typeof props.published === 'boolean') {
            setPublished(props.published);
        }
    }, [props.name, props.description, props.published]);
    // Check input
    var nameOk = name.trim().length > 0 && name.trim().length <= 100;
    var descriptionOk = description.trim().length > 0 && description.trim().length <= 1000;
    var disabled = !nameOk || !descriptionOk;
    // Event handlers
    var handleConfirm = function () {
        props.onConfirm({
            name: name.trim(),
            description: description.trim(),
            published: published,
        });
    };
    var openDeleteDialog = function () { return setDeleteDialogIsOpen(true); };
    var closeDeleteDialog = function () { return setDeleteDialogIsOpen(false); };
    var confirmDelete = function () {
        props.onDeleteConfirm();
        closeDeleteDialog();
    };
    return (_jsxs(_Fragment, { children: [_jsx(AlertDialog, { isOpen: deleteDialogIsOpen, title: "Delete this event?", content: "This action cannot be undone.", onBackdropClick: closeDeleteDialog, buttons: [
                    {
                        label: 'Delete',
                        primary: true,
                        onClick: confirmDelete,
                    },
                    {
                        label: 'Cancel',
                        onClick: closeDeleteDialog,
                    },
                ] }, void 0),
            _jsx(ToolbarWithProps, __assign({ cancel: { type: 'cancel', onClick: props.onCancel }, action: {
                    type: 'done',
                    onClick: disabled ? undefined : handleConfirm,
                } }, { children: "Update Event" }), void 0),
            _jsx(Body, { children: props.loading ? (_jsx(Loading, {}, void 0)) : (_jsxs(_Fragment, { children: [_jsxs(List, { children: [_jsx(ListItemInput, { type: "text", label: "Name", value: name, onChange: setName, placeholder: "My event" }, void 0),
                                _jsx(ListItemTextArea, { label: "Description", value: description, onChange: setDescription, placeholder: "Event description", rows: 20, maxLength: 1000 }, void 0),
                                _jsx(ListItemSwitch, { primary: "Published", wrapPrimary: true, checked: published, onClick: function () { return setPublished(!published); } }, void 0)] }, void 0),
                        _jsx(Button, __assign({ onClick: openDeleteDialog }, { children: "Delete" }), void 0)] }, void 0)) }, void 0)] }, void 0));
}
//# sourceMappingURL=update-event-page-ui.js.map